// @flow
import type { Region } from 'digicel-kaizen-library';

export type SignUpRegionActionType = {
  type: 'SIGNUP_SET_REGION',
  payload: {
    region: ?Region,
  },
};

export function setRegion(region: ?Region): SignUpRegionActionType {
  return {
    type: 'SIGNUP_SET_REGION',
    payload: {
      region,
    },
  };
}
